import { render, staticRenderFns } from "./vehicle-free-inquire.vue?vue&type=template&id=52d0ba3d&scoped=true&"
import script from "./vehicle-free-inquire.vue?vue&type=script&lang=js&"
export * from "./vehicle-free-inquire.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-free-inquire.vue?vue&type=style&index=0&id=52d0ba3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0ba3d",
  null
  
)

export default component.exports